/** Effective KYC mode from `GET /sp/kyc-configuration` (BFP-1119 / BFP-1127 global ∩ tenant). */
export type SpKycMode = 'enabled' | 'disabled' | 'unknown'

export function spKycModeFromWire(raw: string | null | undefined): SpKycMode {
  switch (raw?.trim().toLowerCase()) {
    case 'enabled':
      return 'enabled'
    case 'disabled':
      return 'disabled'
    default:
      return 'unknown'
  }
}

export function isRedeemGatedByTenantKyc(mode: SpKycMode): boolean {
  return mode === 'enabled' || mode === 'unknown'
}
